module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "list-item "
    }, [_c('div', {
      staticClass: "flex-center pb-20 bd-bot"
    }, [_c('div', {
      staticClass: "flex1 fs-30 color-333 font-bold flex-center"
    }, [(item.exceptType == 2) ? _c('span', [_vm._v("订单号：" + _vm._s(item.itemName))]) : _c('span', [_vm._v(_vm._s(item.itemName))])]), _vm._v(" "), (item.status == 0) ? _c('div', {
      staticClass: "info-btn click",
      on: {
        "click": function($event) {
          return _vm.handleConfirm(item)
        }
      }
    }, [_vm._v("确认")]) : _c('div', {
      staticClass: "fs-28 color-main ml-20"
    }, [_vm._v("\n                            已确认\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "mt-20 flex-center"
    }, [_c('div', {
      staticClass: "item-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.img[item.exceptType],
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex1"
    }, [_c('div', {
      staticClass: "fs-32 color-333"
    }, [_vm._v(_vm._s(_vm.listDict[item.exceptType].name))]), _vm._v(" "), _c('div', {
      staticClass: "fs-26 color-999"
    }, [_vm._v(_vm._s(item.createTime))])])])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bb25c40","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/warning/errorWarning.vue
// module id = ZU1E
// module chunks = 51